import React from "react"
import axios from "axios"
import NutritionCalculator from "./components/NutritionCalculator"
import BmiHeaderSection from "../bmiCalculator/components/shared/bmiHeaderSection/BmiHeaderSection"
import addToMailchimp from "gatsby-plugin-mailchimp"
import NutritionCalculatorNewsletter from "./components/NutritionCalculatorNewsletter"
import NutritionIcon from "../../assets/images/icon - food navigator 2.svg"
import NutritionFeaturesSection from "./components/shared/nutritionFeaturesSection/NutritionFeaturesSection"
import LocaleContext from "../../context/LocaleContext"
import translate from "../../translation/translator"
import keys from "../../translation/keys"

let array = []

class NutritionCalculatorContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      searchedProduct: "",
      foodResults: false,
      selectedFood: null,
      testArray: [],
      email: "",
      error: "",
    }
  }

  handleInput = ({ target }) => {
    this.setState({ searchedProduct: target.value })
  }

  handleChangeEmail = e => {
    this.setState({ email: e.target.value })
  }

  handleSubmit = async e => {
    e.preventDefault()
    await addToMailchimp(this.state.email).then(data => {
      if (data.result === "success") {
        this.setState({ error: "Успешно изпратен имейл." })
      }
      if (data.msg === "The email you entered is not valid.") {
        this.setState({ error: "Имейлът е невалиден." })
      }
      if (data.msg.includes("<")) {
        this.setState({ error: "Този имейл вече е използван." })
      }
      if (data.msg.includes("Recipient")) {
        this.setState({ error: "Този имейл вече е използван." })
      }
    })
    this.setState({ email: "" })
  }

  handleSendSearchRequest = e => {
    let searchWord = this.state.searchedProduct
    if (e.key === "Enter") {
      array = []
      axios
        .get(
          `https://api.nal.usda.gov/fdc/v1/foods/search?api_key=T39k4WI8R3IwEykyMWQowADmjVYIR5LCHtXb9JOO&query=${searchWord}&pageSize=10&pageNumber=1&format=full`
        )
        .then(async response => {
          /* eslint-disable-next-line */
          response.data.foods.map(food => {
            axios
              .get(
                `https://api.nal.usda.gov/fdc/v1/food/${food.fdcId}?api_key=T39k4WI8R3IwEykyMWQowADmjVYIR5LCHtXb9JOO`
              )
              .then(response => {
                if (response.data.labelNutrients) {
                  array.push(response.data)
                }

                this.setState({ foodResults: array })
              })
              .catch(e => console.log(e))
          })

          // this.setState({
          //   foodResults: response.data.foods,
          //   selectedFood: null,
          // })
        })
        .catch(e => console.log(e))
    }
  }
  handleGetMeal = meal => {
    axios
      .get(
        `https://api.nal.usda.gov/fdc/v1/food/${meal.fdcId}?api_key=T39k4WI8R3IwEykyMWQowADmjVYIR5LCHtXb9JOO`
      )
      .then(response => {
        this.setState({ selectedFood: response })
      })
      .catch(e => console.log(e))
  }

  handleClear = () => {
    this.setState({
      foodResults: false,
      searchedProduct: "",
      selectedFood: null,
    })
  }

  render() {
    console.log(this.context)

    const {
      searchedProduct,
      foodResults,
      selectedFood,
      error,
      email,
    } = this.state
    const {
      handleInput,
      handleSendSearchRequest,
      handleGetMeal,
      handleClear,
    } = this

    const { locale } = this.context

    const subText = translate(keys.NUTRITION_CONTAINER_SUB_TEXT, locale)
    const text = translate(keys.NUTRITION_CONTAINER_TEXT, locale)
    const title = translate(keys.NUTRITION_CONTAINER_TITE, locale)

    return (
      <React.Fragment>
        <BmiHeaderSection
          subText={subText}
          text={text}
          title={title}
          icon={NutritionIcon}
          locale={locale}
        />
        <NutritionFeaturesSection locale={locale} />
        <NutritionCalculator
          locale={locale}
          handleClear={handleClear}
          selectedFood={selectedFood}
          searchedProduct={searchedProduct}
          handleInput={handleInput}
          handleSendSearchRequest={handleSendSearchRequest}
          foodResults={foodResults}
          handleGetMeal={handleGetMeal}
        />
        <NutritionCalculatorNewsletter
          locale={locale}
          handleSubmit={this.handleSubmit}
          error={error}
          email={email}
          handleChangeEmail={this.handleChangeEmail}
        />
      </React.Fragment>
    )
  }
}

NutritionCalculatorContainer.contextType = LocaleContext

export default NutritionCalculatorContainer
